import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ad41452")

_pushScopeId("data-v-1ad41452")
const _hoisted_1 = { class: "talent_poster" }
const _hoisted_2 = {
  class: "content_container",
  style: {"text-align":"center"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  id: "shareword",
  style: {"height":"6%"}
}, [
  /*#__PURE__*/_createVNode("a", null, [
    /*#__PURE__*/_createVNode("span", null, "长按保存"),
    /*#__PURE__*/_createTextVNode("，晒出我的挑战成绩!")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hideposter')))
      }),
      _createVNode("img", { src: _ctx.posterImg }, null, 8, ["src"]),
      _hoisted_3,
      _createVNode("div", {
        class: "sharebutton",
        id: "sharebutton",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.shareimg && _ctx.shareimg(...args))),
        style: {"display":"none"}
      })
    ])
  ]))
})